import React from "react";
import { Database, Cpu } from "lucide-react";

const fmt = (s) => (s ? new Date(s).toLocaleString() : "—");

const Header = ({ meta }) => {
  return (
    <header className="bg-stadium border-b border-border" data-testid="app-header">
      <div className="max-w-3xl mx-auto px-4 pt-6 pb-5 flex flex-col gap-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-sm bg-[#0A0D0A] border border-border flex items-center justify-center overflow-hidden">
              <img
                src="/apple-touch-icon.png"
                alt="IPL Top-4 Tracker"
                className="w-full h-full object-contain"
                style={{ padding: 1 }}
              />
            </div>
            <div>
              <h1 className="font-display uppercase tracking-tight text-[22px] sm:text-2xl leading-none m-0" data-testid="app-title">
                Top-4 Tracker
              </h1>
              <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mt-0.5">
                {meta.tournament} · {meta.season}
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2 text-[10px] text-muted-foreground uppercase tracking-widest">
            <span className="hidden sm:inline">Live odds</span>
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
            </span>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-2 mt-2">
          <Stat label="Played" value={meta.fixtures_completed} testId="stat-played" />
          <Stat label="Pending" value={meta.fixtures_pending} testId="stat-pending" />
          <Stat
            label="Method"
            value={meta.method === "monte_carlo" ? "MC" : meta.method === "brute_force" ? "BF" : "—"}
            testId="stat-method"
            sub={`${meta.total_scenarios.toLocaleString()} sims`}
          />
        </div>

        <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[10px] text-muted-foreground">
          <span className="inline-flex items-center gap-1">
            <Database className="w-3 h-3" />
            Generated {fmt(meta.generated_at)}
          </span>
          <span className="inline-flex items-center gap-1">
            <Cpu className="w-3 h-3" />
            {meta.method === "brute_force" ? "Exact enumeration" : "Monte-Carlo simulation"}
          </span>
        </div>
      </div>
    </header>
  );
};

const Stat = ({ label, value, sub, testId }) => (
  <div
    className="bg-card/80 border border-border rounded-sm px-3 py-2"
    data-testid={testId}
  >
    <div className="text-[9px] uppercase tracking-[0.2em] text-muted-foreground">
      {label}
    </div>
    <div className="num text-2xl text-foreground leading-none mt-0.5">{value}</div>
    {sub && (
      <div className="text-[9px] uppercase tracking-widest text-muted-foreground mt-1">
        {sub}
      </div>
    )}
  </div>
);

export default Header;
